import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import { fetchCartRecos } from 'actions/cart';
import { isDesktop } from 'helpers/ClientUtils';
import MelodyCarousel from 'components/common/MelodyCarousel';
import ProductImage from 'components/cart/ProductImage';
import marketplace from 'cfg/marketplace.json';
import css from 'styles/components/cart/cartRecos.scss';

const { cart: { showRecos } } = marketplace;

export class CartRecos extends Component {
  static defaultProps = {
    showRecos
  };

  static contextTypes = {
    testId: PropTypes.func
  };

  componentDidMount() {
    const {
      cart: { cartObj },
      recos,
      fetchCartRecos,
      showRecos
    } = this.props;

    // if recos are enabled, is desktop only, and has not fetched recos already
    const shouldFetchRecos = showRecos && isDesktop(marketplace) && !recos?.recos;
    shouldFetchRecos && fetchCartRecos({ ...cartObj });
  }

  render() {
    const { testId } = this.context;

    const { recos: { recos, title } = {} } = this.props;
    if (!recos?.length) {
      return null;
    }

    return (
      <div className={css.container}>
        <h3>{title}</h3>
        <MelodyCarousel>
          {recos.map(item => {
            const { styleId, productUrl, brandName, productName } = item;
            return (
              <div className={css.item} key={styleId} data-test-id={testId('cartReco')}>
                <ProductImage className={css.image} item={item}/>
                <Link to={productUrl}>
                  <span data-test-id={testId('recoBrandName')}>{brandName}</span>
                  <span data-test-id={testId('recoProductName')}>{productName}</span>
                </Link>
              </div>
            );
          }
          )}
        </MelodyCarousel>
      </div>
    );
  }
}

export const mapStateToProps = state => {
  const {
    cart,
    recos
  } = state;

  return {
    cart,
    recos: recos.janus?.['zap_cart']
  };
};

export default connect(mapStateToProps, { fetchCartRecos })(CartRecos);
